module.exports = __webpack_public_path__ + "static/Joshua_Maddox_Resume-4cd844c808a5c1d8a2e31d108f60fb0e.pdf";